import { z } from 'zod';
export const StudentDtoSchema = z.object({
    id: z.string().uuid(),
    fullName: z.string(),
    email: z.string().email().nullable(),
    phone: z.string().nullable(),
    grade: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    // Есть ли у ученика привязанная учётка (STUDENT user) после принятого инвайта.
    hasUser: z.boolean(),
});
const EmptyToNull = (inner) => z.preprocess((v) => (v === '' ? null : v), z.union([inner, z.null()]));
export const CreateStudentSchema = z.object({
    fullName: z.string().trim().min(1).max(200),
    email: EmptyToNull(z.string().email()).optional(),
    phone: EmptyToNull(z.string().max(40)).optional(),
    grade: EmptyToNull(z.string().max(40)).optional(),
    notes: EmptyToNull(z.string().max(10_000)).optional(),
});
export const UpdateStudentSchema = CreateStudentSchema.partial();
export const StudentsListQuerySchema = z.object({
    q: z.string().trim().max(200).optional(),
    sort: z.enum(['fullName', 'createdAt', 'updatedAt']).default('fullName'),
    order: z.enum(['asc', 'desc']).default('asc'),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export const StudentsListResponseSchema = z.object({
    items: z.array(StudentDtoSchema),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
});
//# sourceMappingURL=students.js.map